import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type {
    InboundTextLink,
    InboundTextLinkDetails,
    InboundTextLinkListParams,
    InboundTextLinkPayload,
} from './adminInboundTextClient.types';

class AdminInboundTextClient extends BaseClient {
    getLinks(
        params?: InboundTextLinkListParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<InboundTextLink>> {
        return this.makeCoreApiRequest('/api/admin/inbound-text/links', 'get', null, params, config);
    }

    getLink(linkId: number): AxiosPromise<InboundTextLinkDetails> {
        return this.makeCoreApiRequest(`/api/admin/inbound-text/links/${linkId}`);
    }

    createLink(link: InboundTextLinkPayload): AxiosPromise<{ data: Pick<InboundTextLink, 'id'> }> {
        return this.makeCoreApiRequest('/api/admin/inbound-text/links', 'post', link);
    }

    updateLink(linkId: number, link: InboundTextLinkPayload): AxiosPromise<{ data: InboundTextLink }> {
        return this.makeCoreApiRequest(`/api/admin/inbound-text/links/${linkId}`, 'put', link);
    }

    deleteLink(linkId: number): AxiosPromise<void> {
        return this.makeCoreApiRequest(`/api/admin/inbound-text/links/${linkId}`, 'delete');
    }
}

export default new AdminInboundTextClient();
